/*Author: Vinay D S*/
import React from "react";
import history from "helper/history";
import SignInContainer from "@techsoftware/happay-widgets/SignInContainer";
import { CustomGrid as Grid } from "../../customComponents/components";

import {
    CustomPrimaryButton as SaveButton,
    CustomSecondaryButton as CancelButton,
    CustomTextField as TextField,
    customTertiaryButton as TertiaryButton
} from "../../customComponents/components";

import Style from "../../constants/style";
import Common from "../../constants/common";

import * as LoginAction from "../../actions/loginaction";
import LoginStore from "../../stores/loginstore";

import i18n from "../../i18nNext";
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";

export default class setPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            passwordConfirm: "",
            passwordOtp: props.otpPass || "",
            submitButtonDisable: true
        };
        this._handleSubmit = this._handleSubmit.bind(this);
        this._loginStoreChange = this._loginStoreChange.bind(this);
    }

    componentDidMount() {
        LoginStore.on("change", this._loginStoreChange);
    }

    componentWillUnmount() {
        LoginStore.removeListener("change", this._loginStoreChange);
    }

    _loginStoreChange(type) {
        if (type === "errorMsg") {
            this.setState({ submitButtonDisable: false });
        }
    }

    _handleSubmit(event) {
        event.preventDefault();

        let { otp, password, passwordConfirm } = this.state;
        if (!password) {
            LoginAction.setAnyKey("errorMsg", "Enter a valid password");
            return false;
        }
        if (!passwordConfirm) {
            LoginAction.setAnyKey("errorMsg", "Confirm password");
            return false;
        }
        if (password != passwordConfirm) {
            LoginAction.setAnyKey("errorMsg", "Password and confirm password not matching");
            return false;
        }

        let data = {
            otp: otp,
            new_passwd: passwordConfirm
        };
        this.setState({ submitButtonDisable: true });
        LoginAction.setPassword(data);
    }

    _skipToDashboard() {
        let pageName = "/dashboard";
        history.push(pageName);
    }
    _resendOTP() {
        let pattern = /[0-9]/g,
            mobileEmailVariable = LoginStore._getField("user");
        let mob = {},
            code = LoginStore._getField("mobileExt"),
            countryCode = LoginStore._getField("c_code");
        if (mobileEmailVariable.length == 10)
            if (mobileEmailVariable.match(pattern)) {
                mob.mobile_number = mobileEmailVariable;
                mob.mobile_extension = countryCode || code;
            } else mob.email_id = mobileNo || this.state.mobile;
        LoginAction.sendOTPApi(mob);
    }

    render() {
        const { ProductLogo } = this.props;
        return (
            <SignInContainer containerClassName={`signin-container ${Common._checkIfHdfcUrl() ? 'hdfcPortal': 'happayPortal'}`}>
                <Grid className="padding-20" sm={12} xs={24} md={12} lg={7} xl={6} isWidgetComp>
                    <div className="align-center">
                        <img src={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo} width="150px" height="50px" />
                    </div>
                    <div className="font-20 fw-500 margin-t-40 margin-b-20 hw-heading-text align-center">
                        Set Password
                    </div>
                    <form onSubmit={this._handleSubmit} autoComplete="off">
                        <div style={{ margin: 40 }}>
                            <div>
                                <TextField
                                    id="passOtp"
                                    style={{ width: "100%" }}
                                    autoComplete="off"
                                    value={this.state.passwordOtp}
                                    underlineFocusStyle={Style.floatingUnderLineStyle}
                                    floatingLabelStyle={Style.loginPage.floatingTextStyle}
                                    floatingLabelFocusStyle={Style.floatingLabelStyle}
                                    maxLength={6}
                                    onChange={(event, value) => {
                                        this.setState({ passwordOtp: value });
                                    }}
                                    floatingLabelText={i18n.t("lbl.enterOTP")}
                                    required
                                    isWidgetComp
                                    isNumberType
                                />
                            </div>
                            <div className="margin-t-10 resendButton">
                                <TertiaryButton
                                    label={i18n.t("btn.resendOtp")}
                                    onClick={this._resendOTP.bind(this)}
                                />
                            </div>
                            <div>
                                <TextField
                                    id="password"
                                    style={{ width: "100%" }}
                                    hintText="********"
                                    type="password"
                                    onChange={(event, value) => {
                                        this.setState({ password: value });
                                    }}
                                    autoFocus
                                    autoComplete="new-password"
                                    value={this.state.password}
                                    floatingLabelText={i18n.t("placeholder.enterPassword")}
                                    underlineFocusStyle={Style.floatingUnderLineStyle}
                                    floatingLabelStyle={Style.loginPage.floatingTextStyle}
                                    floatingLabelFocusStyle={Style.floatingLabelStyle}
                                    isWidgetComp
                                />
                            </div>
                            <div>
                                <TextField
                                    id="confirmPassword"
                                    style={{ width: "100%" }}
                                    hintText="********"
                                    type="password"
                                    onChange={(event, value) => {
                                        this.setState({ passwordConfirm: value });
                                    }}
                                    autoFocus
                                    autoComplete="new-password"
                                    value={this.state.passwordConfirm}
                                    floatingLabelText={i18n.t("placeholder.enterConfirmPassword")}
                                    underlineFocusStyle={Style.floatingUnderLineStyle}
                                    floatingLabelStyle={Style.loginPage.floatingTextStyle}
                                    floatingLabelFocusStyle={Style.floatingLabelStyle}
                                    isWidgetComp
                                />
                            </div>
                            <div className="margin-t-40 setPasswordButton">
                                <CancelButton
                                    label="Skip"
                                    onClick={this._skipToDashboard.bind(this)}
                                    isWidgetComp
                                    size="medium"
                                />
                                <SaveButton label="Set" type="submit" isWidgetComp size="medium" />
                            </div>
                        </div>
                    </form>
                </Grid>
            </SignInContainer>
        );
    }
}
